module.exports = __webpack_public_path__ + "static/media/img-1.7c23704c.jpg";